// extracted by mini-css-extract-plugin
export default {"container":"APIOverview_container__Trtd5","breadcrumb":"APIOverview_breadcrumb__uJeY9","header":"APIOverview_header__JTSm9","toggleSection":"APIOverview_toggleSection__Yt35w"};